// Instagram reels / posts displayed on the home page.
//
// Paste the URL of each reel or post you want to feature. Open the reel on
// instagram.com, click the share icon, and copy the URL. It looks like:
//   https://www.instagram.com/reel/XXXXXXXX/
//   https://www.instagram.com/p/XXXXXXXX/
//
// 4 to 8 entries works well. The section is hidden entirely if the array is empty.

export const reels = [
  'https://www.instagram.com/reel/DXgAtolE4ox/',
  'https://www.instagram.com/reel/DTl5sM4lRpp/',
  'https://www.instagram.com/reel/DY3OdzBpOyB/',
  // 'https://www.instagram.com/reel/REPLACE_ME_4/',
];
